import React from 'react';
import { Link } from 'react-router-dom';
import { Mark } from './Logo';

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 grid-backdrop opacity-60" aria-hidden />
      <div className="container-page relative flex min-h-[calc(100vh-4rem)] items-center justify-center py-14">
        <div className="w-full max-w-md">
          <Link to="/" className="mb-8 flex justify-center">
            <Mark size={40} />
          </Link>
          <div className="rounded-2xl border border-border bg-card p-8 shadow-lift">
            <h1 className="font-display text-2xl font-bold tracking-tight text-foreground">{title}</h1>
            <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>
            <div className="mt-7">{children}</div>
          </div>
          <p className="mt-6 text-center text-sm text-muted-foreground">{footer}</p>
        </div>
      </div>
    </div>
  );
}
